export default {
    view_map: 'View on map',
    no_offers: 'This company does not have any services.',
    no_offers_user: 'This user does not have any services',
    no_results: 'No results found!',
}
